import Image from "next/image";
import Link from "@/components/UI/Link/Link";
import Button from "@/components/UI/Button/Button";
import Card from "@/components/UI/Card/Card";
import { PublicPageZip } from "@/utils/page";
import { JobGetResponse } from "@/types/job";
import Section from "@/components/Section/Section";
import SectionContainer from "@/components/Section/SectionContainer";
import SectionHeader from "@/components/Section/SectionHeader";

interface Section10Props extends React.HTMLAttributes<HTMLElement> {
  job?: JobGetResponse;
  page: any;
  section: any;
}

const HighlightsSection = ({ job, page, section, ...props }: Section10Props) => {
  return (
    <Section section={section} {...props}>
      <SectionContainer section={section}>
        <SectionHeader section={section} />
        {section?.Cards?.length > 0 && (
          <div className="grid grid-flow-col grid-rows-3 gap-10">
            {section?.Cards?.map((item: any) => {
              return (
                <Card className="flex rounded-md p-8" key={item?.id}>
                  <div className="flex w-full flex-1 shrink-0 flex-col gap-8">
                    {item.Image?.data?.attributes && (
                      <Image
                        alt={item?.Image?.data?.attributes?.alternativeText}
                        className="w-20"
                        src={item?.Image?.data?.attributes?.url}
                        height={item?.Image.data.attributes?.height ?? "100"}
                        width={item?.Image?.data?.attributes?.width ?? "100"}
                      />
                    )}
                    <div className="w-1/2 text-2xl text-vpGray-700">{item?.Caption}</div>
                    <div className="flex gap-4">
                      {item?.PrimaryButtonUrl && item?.PrimaryButtonValue && (
                        <Link className="block" href={item?.PrimaryButtonUrl ?? ""} variant="external">
                          <Button className="mx-auto">{item?.PrimaryButtonValue}</Button>
                        </Link>
                      )}
                      {item?.SecondaryButtonUrl && item?.SecondaryButtonValue && (
                        <Link className="block" href={item?.SecondaryButtonUrl ?? ""} variant="external">
                          <Button className="mx-auto" variant="text">
                            {item?.SecondaryButtonValue}
                          </Button>
                        </Link>
                      )}
                    </div>
                  </div>
                  <iframe className="hidden w-full flex-1 lg:block" src={item?.EmbedUrl} />
                </Card>
              );
            })}
          </div>
        )}
      </SectionContainer>
    </Section>
  );
};

export default HighlightsSection;
